import React from "react";
import { DateRangePicker } from "rsuite";
import { GetUserDateFormat } from "../utils/helper";

interface Props {
  //   disabledDate?: Date; // Disable the previous dates
  placeholder?: string;
  onChange?: any;
  value?: any;
  disableFurtherDate?: boolean;
  defaultValue?: [Date, Date];
}

export const EPDateRangePicker: React.FC<Props> = ({
  placeholder,
  disableFurtherDate,
  onChange,
  value,
  defaultValue,
}) => {
  const disabledDate = disableFurtherDate
    ? (date: Date) => date > new Date()
    : undefined;
  return (
    <DateRangePicker
      defaultValue={defaultValue}
      disabledDate={disabledDate}
      value={value}
      format={GetUserDateFormat('date')}
      placeholder={placeholder}
      onChange={(date) => {
        onChange(date);
      }}
    />
  );
};
